import { AnimalFind } from "./AnimalFind";
export default AnimalFind;